<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "KYC",
  data() {
    return {};
  },
  components: {},
  computed: {},
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/SignupKyc.vue